import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { LLFormComponent } from '../../components/areas/products/ll-form/ll-form.component';


export interface DeactivationGuard {
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class LLFormGuard implements CanDeactivate<LLFormComponent> {

  canDeactivate(
    component: DeactivationGuard): Observable<boolean> | Promise<boolean> | boolean {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}

